"use client";

import styled from "styled-components";
import Icon from "../icon";
import Image from "../image";

export const Div = styled.div`
  position: relative;
`;

export const Select = styled.select``;

export const Option = styled.option``;
export const ImageFlag = styled(Image)`
  width: 19px;
  height: 19px;
`;

export const IconArrow = styled(Icon)`
  svg {
    width: 9px;
    path {
      fill: transparent;
      stroke: var(--colorTitle);
    }
  }
`;

export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  padding: 3px 6px 3px 3px;
  border-radius: 100px;
  border: 1px solid #acbacd;
  background-color: transparent;
  cursor: pointer;
  gap: 5px;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border: none;
  border-radius: 15px;
  background-color: transparent;
  z-index: 999;
  width: fit-content;
  transform: translateX(0px);
  margin-top: 4px;
  background: var(--backgroundColorCard);
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
  min-width: 155px;
`;

export const DropdownItem = styled.li`
  padding: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-wrap: nowrap;
  gap: 5px;
  font-family: "Roboto Light";
  width: 100%;

  &:first-child {
    border-radius: 15px 15px 0 0;
  }

  &:last-child {
    border-radius: 0 0 15px 15px;
  }

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const Text = styled.span`
  display: block;
  font-size: 12px;
`;
